import { animate, state, style, transition, trigger } from '@angular/animations';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Host,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewEncapsulation,
} from '@angular/core';
import { Subject } from 'rxjs';
import { ChevronDown } from '../../icon/icon-map';
import { PhxCollapseComponent } from '../phx-collapse.component';
import { PhxCollapseType, PHX_COLLAPSE_TYPE } from '../phx-collapse.types';

@Component({
  selector: 'phx-collapse-item',
  templateUrl: './phx-collapse-item.component.html',
  styleUrls: ['./phx-collapse-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'phx-collapse-item',
    '[class.phx-collapse-item-active]': 'phxActive',
  },
  animations: [
    trigger('collapseMotion', [
      state('expanded', style({ height: '*' })),
      state('collapsed', style({ height: 0, overflow: 'hidden' })),
      state('hidden', style({ height: 0, overflow: 'hidden', borderTopWidth: '0' })),
      transition('expanded => collapsed', animate('150ms ease-in-out')),
      transition('expanded => hidden', animate('150ms ease-in-out')),
      transition('collapsed => expanded', animate('150ms ease-in-out')),
      transition('hidden => expanded', animate('150ms ease-in-out')),
    ]),
  ],
})
export class PhxCollapseItemComponent implements OnInit, OnDestroy {
  @Input() phxHeader: string | TemplateRef<any>;
  @Input() phxSubtext: string;
  @Input() phxActive: boolean = false;
  @Output() phxActiveChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  public readonly ChevronDownIcon: string = ChevronDown;
  private _destroy$: Subject<void> = new Subject<void>();

  constructor(@Host() private _phxCollapseComponent: PhxCollapseComponent, private _cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this._phxCollapseComponent.addItem(this);
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
    this._phxCollapseComponent.removeItem(this);
  }

  private get _type(): PhxCollapseType {
    return this._phxCollapseComponent.phxType;
  }

  public get collapseIconSize(): number {
    if (this._type === PHX_COLLAPSE_TYPE.CAPTION) return 16;
    if (this._type === PHX_COLLAPSE_TYPE.TITLE) return 32;
    return 20;
  }

  public get isHeaderTemplate(): boolean {
    return this.phxHeader instanceof TemplateRef;
  }

  public get headerTemplate(): TemplateRef<any> | null {
    return this.phxHeader instanceof TemplateRef ? this.phxHeader : null;
  }

  public get shouldShowSubtext(): boolean {
    return this.phxSubtext && this._type !== PHX_COLLAPSE_TYPE.CAPTION && (this._type === PHX_COLLAPSE_TYPE.DEFAULT ? this.phxActive : true);
  }

  public get isCompact(): boolean {
    return this._phxCollapseComponent.phxCompact;
  }

  public markForCheck(): void {
    this._cdr.markForCheck();
  }

  public headerClick(): void {
    this._phxCollapseComponent.click(this);
  }
}
